import { Flex, Text, ErrorOutline } from "@shared/primitive-components"
import * as styles from "../styles"

export const NO_DATA_MESSAGE_TEST_IDS = {
  text: `no_data_message_text`,
}

export const NoDataMessage = () => (
  <Flex justifyContent="center" alignItems="center" css={styles.container}>
    {ErrorOutline}
    <Text css={styles.text} data-testid={NO_DATA_MESSAGE_TEST_IDS?.text}>
      No Data
    </Text>
  </Flex>
)
